var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4219 4.34243C11.4219 4.45269 11.1108 6.69445 10.1775 7.6132C11.4219 2.10526 6.75523 1 6.75523 1C6.75523 1 7.47079 3.75443 6.44412 5.07744C6.3819 3.57068 5.66634 2.65193 5.66634 2.65193C5.13745 5.37144 3.33301 7.72346 3.33301 9.48746C3.33301 12.5378 5.41745 15 7.99967 15C10.5819 15 12.3552 12.7895 12.6663 9.48746C12.6663 7.28245 12.6663 5.78947 11.4219 4.34243Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.55523 11.4474C9.55523 12.4053 8.87079 13.1579 7.99967 13.1579C7.12856 13.1579 6.44412 12.4053 6.44412 11.4474C6.44412 10.4895 7.99967 7.17108 7.99967 7.17108C7.99967 7.17108 9.55523 10.4895 9.55523 11.4474Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeat);
export default __webpack_public_path__ + "static/media/heat.383e8643eed947c6f858cbdddbd0c1b9.svg";
export { ForwardRef as ReactComponent };